<template>
  <div>
    <Modal :title="`「${serverName}」重置密码`" v-model="changePasswordModel">
      <Alert show-icon type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
      <Form ref="reqForm" :model="reqForm" :rules="reqRule">
        <FormItem prop="adminPass" label="新密码">
          <Input v-model="reqForm.adminPass" type="password"/>
        </FormItem>
        <FormItem prop="adminPass2" label="确认密码">
          <Input v-model="reqForm.adminPass2" type="password"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="changePasswordModel = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudServer } from '@/api/private-cloud/server'
export default {
  name: 'server-change-password',
  data () {
    return {
      changePasswordModel: false,
      submitting: false,
      errorMsg: null,
      serverId: '',
      serverName: '',
      reqForm: {
        adminPass: '',
        adminPass2: ''
      },
      reqRule: {
        adminPass: [
          { required: true, message: '请填写新密码', trigger: 'blur' },
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        adminPass2: { required: true, message: '', trigger: 'blur', validator: this.validPasswordRule }
      }
    }
  },
  methods: {
    openModal (id, name) {
      this.$refs.reqForm.resetFields()
      this.serverId = id
      this.serverName = name
      this.changePasswordModel = true
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'changePassword': {
              adminPass: this.reqForm.adminPass
            }
          }
          this.submitting = true
          actionPrivateCloudServer(reqData, this.serverId).then(res => {
            this.changePasswordModel = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.response) {
              this.errorMsg = res.response.data
              this.$Notice.error({
                title: '操作失败！',
                desc: res.response.data
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 二次确认密码规则
    validPasswordRule (rule, value, callback) {
      if (!this.reqForm.adminPass) {
        callback(new Error('确认密码不能为空'))
      } else if (this.reqForm.adminPass !== this.reqForm.adminPass2) {
        callback(new Error('两次输入的密码不同'))
      } else {
        callback()
      }
    }
  }
}
</script>

<style scoped>

</style>
